export default __webpack_public_path__ + "static/media/kitchen3-after3-1024w.b26c892e.webp";